import _createForOfIteratorHelper from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _readOnlyError from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/readOnlyError.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import selectPerson from '@/components/select-person/genera';
import { queryNoticeAuthorityDetails, queryNoticeAuthority, saveNoticeAuthority } from '@/api/notice/noticeApi.js';
import { queryOrgan, queryPostAuth, queryPostAuthDet, savePostAuth } from '@/api/commonApi.js';
export default {
  data: function data() {
    var userTabList = [{
      title: '组织',
      value: 0
    }];
    return {
      userTabList: userTabList,
      businessId: 2,
      // 业务id 1公文流转 2通知通告
      jobLoading: false,
      authLoading: false,
      visibleAuth: false,
      activeKey: 1,
      title: '',
      objAuth: {
        organizeId: '',
        // 组织编号
        organizeType: '2',
        // 组织结构类型(1 行政 2 党委 3处室 4 教学 5 工会 6 教研)
        dataAuthType: this.dataAuthType // 数据权限类型(1:通知公告,2:公文流转)
      },
      jobList: [],
      organData: [],
      radioStyle: {
        display: 'block',
        height: '50px',
        lineHeight: '50px'
      },
      searchValue: '',
      autoExpandParent: true,
      commData: [],
      copyCommData: [],
      expandedKeys: [],
      selectedKeys: [],
      dataList: [],
      authList: [],
      formObject: {
        dataAuthType: this.dataAuthType,
        // 数据权限类型(1:通知公告,2:公文流转)
        authType: '',
        // 授权组织类型 1 行政 2 党委 3处室 4 教学 5 工会 6 教研
        authOrganId: '',
        // 授权组织不能为空
        authPostId: '',
        // 授权岗位不能为空
        postAuths: [] // 岗位权限集合
      },
      authCateId: ''
    };
  },
  mounted: function mounted() {
    this.getOrganList();
  },
  methods: {
    /*
     * 查询组织机构
     */
    getOrganList: function getOrganList() {
      var _this = this;
      queryOrgan().then(function (res) {
        _this.organData = res.data;
        _this.tabOrgan(2);
      });
    },
    /*
     * 根据组织架构的切换查询相关数据
     */
    tabOrgan: function tabOrgan() {
      var $set = this.$set,
        organData = this.organData,
        objAuth = this.objAuth,
        getByOrganIdAuthority = this.getByOrganIdAuthority,
        formObject = this.formObject,
        searchValue = this.searchValue,
        generateList = this.generateList;
      var newOrgan = [];
      // 切换时清空数据
      this.searchValue = '';
      this.visibleAuth = false;
      // 根据切换类型查询数据 
      if (objAuth.organizeType == 2) {
        this.commData = organData.part;
        this.selectedKeys = [organData.part[0].id];
        if (!objAuth.organizeId) {
          $set(objAuth, 'organizeId', organData.part[0].id);
        }
        getByOrganIdAuthority();
      } else if (objAuth.organizeType == 3) {
        this.commData = organData.office;
        this.selectedKeys = [organData.office[0].id];
        if (!objAuth.organizeId) {
          $set(objAuth, 'organizeId', organData.office[0].id);
        }
        getByOrganIdAuthority();
      } else if (objAuth.organizeType == 4) {
        this.commData = organData.teacher;
        this.selectedKeys = [organData.teacher[0].id];
        if (!objAuth.organizeId) {
          $set(objAuth, 'organizeId', organData.teacher[0].id);
        }
        getByOrganIdAuthority();
      } else if (objAuth.organizeType == 5) {
        this.commData = organData.labour;
        this.selectedKeys = [organData.labour[0].id];
        if (!objAuth.organizeId) {
          $set(objAuth, 'organizeId', organData.labour[0].id);
        }
        getByOrganIdAuthority();
      } else if (objAuth.organizeType == 6) {
        this.commData = organData.research;
        this.selectedKeys = [organData.research[0].id];
        if (!objAuth.organizeId) {
          $set(objAuth, 'organizeId', organData.research[0].id);
        }
        getByOrganIdAuthority();
      }

      // 搜索赋值数据
      generateList(this.commData);
      // 数据进行拷贝，还原时使用
      Object.assign(this, {
        copyCommData: JSON.stringify(this.commData)
      });
    },
    /*
     * 查询数据权限
     */
    getByOrganIdAuthority: function getByOrganIdAuthority() {
      var _this2 = this;
      var $set = this.$set,
        objAuth = this.objAuth;
      this.jobLoading = true;
      queryPostAuth(objAuth).then(function (res) {
        _this2.jobLoading = false;
        if (res.data.code === 200) {
          _this2.jobList = res.data.data;
          $set(objAuth, 'organizeId', objAuth.organizeId);
          if (_this2.jobList.length > 0) {
            _this2.selectedKeys = [objAuth.organizeId];
          }
        }
      });
    },
    selectClick: function selectClick(info, event) {
      var $set = this.$set,
        objAuth = this.objAuth,
        getByOrganIdAuthority = this.getByOrganIdAuthority;
      this.selectedKeys = info;
      if (info[0]) {
        $set(objAuth, 'organizeId', info[0]);
      }
      getByOrganIdAuthority();
    },
    showDrawers: function showDrawers(item) {
      var _this3 = this;
      var $set = this.$set,
        formObject = this.formObject,
        objAuth = this.objAuth;
      this.visibleAuth = true;
      this.authLoading = true;
      this.title = "\u8BBE\u7F6E\u3010".concat(item.organName || '', " / ").concat(item.postName || '', "\u3011\u5C97\u4F4D\u6743\u9650\u8303\u56F4");
      $set(formObject, 'authOrganId', item.organId);
      $set(formObject, 'authPostId', item.postId);
      $set(formObject, 'authType', objAuth.organizeType);
      var objAuthDet = {
        dataAuthType: objAuth.dataAuthType,
        organizeId: item.organId,
        postId: item.postId
      };
      queryPostAuthDet(objAuthDet).then(function (res) {
        _this3.authList = res.data.data;
        _this3.authCateId = res.data.data[0].authCateId;
        // 数据处理
        _.map(_this3.authList, function (item) {
          if (item.customizes.length > 0) {
            var customize = {
              organData: []
            };
            _.forEach(item.customizes, function (custom) {
              customize.organData.push({
                actorId: custom.organizeid,
                actorName: custom.organizename,
                typeId: custom.organizetype,
                tabType: 0
              });
            });
            item.customize = customize;
          } else {
            item.customize = {};
          }
          return item;
        });
        $set(formObject, 'postAuths', _this3.authList);
        _this3.authLoading = false;
      });
    },
    submit: function submit() {
      var $message = this.$message,
        formObject = this.formObject,
        getOrganList = this.getOrganList;

      // 自定义数据处理 customize postAuths
      _.map(formObject.postAuths, function (item) {
        var customizes = [];
        if (item.checkScope == 20005) {
          _.forEach(item.customize.organData, function (organ) {
            customizes.push({
              organizeid: organ.actorId,
              organizetype: organ.typeId
            });
          });
        }
        item.customizes = customizes;
        return item;
      });
      savePostAuth(formObject).then(function (res) {
        if (res.data.code === 200) {
          $message.success('操作成功');
          getOrganList();
        }
      });
    },
    onClose: function onClose() {
      this.visibleAuth = false;
    },
    onExpand: function onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    onSearch: function onSearch(e) {
      var _this4 = this;
      var dataList = this.dataList,
        getParentKey = this.getParentKey;
      var value = e.target.value;
      // 需要展开的节点
      var expandedKeys = dataList.map(function (item) {
        if (item.title.indexOf(value) > -1) {
          return getParentKey(item.id, _this4.commData);
        }
        return null;
      }).filter(function (item, i, self) {
        return item && self.indexOf(item) === i;
      });
      // 如果搜索条件不为空，进行筛选，反之数据还原
      if (value) {
        this.commData = JSON.parse(this.copyCommData);
        // 调用筛选方法
        this.commData = this.arrayTreeFilter(this.commData, this.filterFn, value);
      } else {
        this.commData = JSON.parse(this.copyCommData);
      }
      Object.assign(this, {
        expandedKeys: expandedKeys,
        searchValue: value,
        autoExpandParent: true
      });
    },
    generateList: function generateList(data) {
      var generateList = this.generateList;
      for (var i = 0; i < data.length; i++) {
        var node = data[i];
        this.dataList.push({
          id: node.id,
          title: node.title
        });
        if (node.children) {
          generateList(node.children);
        }
      }
    },
    getParentKey: function getParentKey(id, tree) {
      var getParentKey = this.getParentKey;
      var parentKey;
      for (var i = 0; i < tree.length; i++) {
        var node = tree[i];
        if (node.children) {
          if (node.children.some(function (item) {
            return item.id === id;
          })) {
            parentKey = node.id;
          } else if (getParentKey(id, node.children)) {
            parentKey = getParentKey(id, node.children);
          }
        }
      }
      return parentKey;
    },
    arrayTreeFilter: function arrayTreeFilter(data, predicate, filterText) {
      var nodes = data;
      // 如果已经没有节点了，结束递归
      if (!(nodes && nodes.length)) {
        return;
      }
      var newChildren = [];
      var _iterator = _createForOfIteratorHelper(nodes),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var node = _step.value;
          if (predicate(node, filterText)) {
            // 如果自己（节点）符合条件，直接加入到新的节点集
            newChildren.push(node);
            // 并接着处理其 children,（因为父节点符合，子节点一定要在，所以这一步就不递归了）
            node.children = this.arrayTreeFilter(node.children, predicate, filterText);
          } else {
            // 如果自己不符合条件，需要根据子集来判断它是否将其加入新节点集
            // 根据递归调用 arrayTreeFilter() 的返回值来判断
            var subs = this.arrayTreeFilter(node.children, predicate, filterText);
            // 以下两个条件任何一个成立，当前节点都应该加入到新子节点集中
            // 1. 子孙节点中存在符合条件的，即 subs 数组中有值
            // 2. 自己本身符合条件
            if (subs && subs.length || predicate(node, filterText)) {
              node.children = subs;
              newChildren.push(node);
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return newChildren;
    },
    filterFn: function filterFn(data, filterText) {
      //过滤函数
      if (!filterText) {
        return true;
      }
      return new RegExp(filterText, "i").test(data.title) //我是一title过滤 ，你可以根据自己需求改动
;
    }
  },
  props: {
    dataAuthType: {
      type: Number,
      default: 0
    }
  },
  components: {
    selectPerson: selectPerson
  }
};